import { motion } from 'framer-motion';
import { styled } from 'styled-components';

export const ButtonContainer = styled(motion.div)`
  height: 48px;
  padding: 0 40px;
  position: relative;
  background-color: var(--pcm-primary-button-bankground);
  border-radius: var(--pcm-rounded-lg);
  color: var(--pcm-primary-button-color);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 200ms ease;
  width: auto;
  max-width: 360px;
  width: 100%;
`;
